// Ordinary player-health subset of game_obj.cpp ObjHit. Context-specific
// bosses, vehicles, shields, death pieces and stud scattering are external.
export class PlayerHealth {
  constructor(maximum) {
    if (!Number.isInteger(maximum) || maximum < 1 || maximum > 255) throw new Error('Invalid original hit-point count.');
    this.maximum = maximum; this.reset();
  }
  reset() { this.current = this.maximum; this.flicker = 0; this.spawnProtection = 0; }
  update(dt) {
    if (!Number.isFinite(dt) || dt < 0) throw new Error('Invalid health elapsed time.');
    this.flicker = Math.max(0, this.flicker - dt); this.spawnProtection = Math.max(0, this.spawnProtection - dt);
  }
  hit(amount, { invincible = false, attackerPlayerControlled = false } = {}) {
    if (!Number.isInteger(amount) || amount < -1 || amount > 255) throw new Error('Invalid hit damage.');
    if (this.spawnProtection > 0 || (amount !== -1 && this.flicker > 0 && !attackerPlayerControlled) || !this.current || (amount !== -1 && invincible)) return { damage: 0, killed: false };
    const previous = this.current;
    this.current = amount === -1 ? 0 : Math.max(0, previous - amount);
    if (this.current && amount !== 0) this.flicker = 0.4;
    return { damage: previous - this.current, killed: previous > 0 && this.current === 0 };
  }
  heal(amount = 1) {
    if (!Number.isInteger(amount) || amount < 0 || amount > 255) throw new Error('Invalid healing amount.');
    if (!this.current) return 0;
    const before = this.current; this.current = Math.min(this.maximum, before + amount); return this.current - before;
  }
}
